import type { AdminImportType } from "./types";

const SAMPLES: Record<AdminImportType, { fileName: string; content: string }> = {
  LOCATIONS: {
    fileName: "coprint-locations-template.csv",
    content: [
      'Store Code,Store Name,Store group name,Store Address,Store contact person name,Store contact person Phone,"Store geoLocation(lat,long)"',
      'BLR-001,Indiranagar Flagship,,100 Feet Road Indiranagar Bengaluru,Asha Rao,9876543210,"12.971891,77.641151"'
    ].join("\n")
  },
  CATALOGUE: {
    fileName: "coprint-item-catalogue-template.csv",
    content: [
      "Item Name,Item Code,Description,UOM,Slab Start,Slab End,Buy Rate,Sell Rate,HSN/SAC Code,GST Rate",
      "Flex Print,FLX-SFT-001,Outdoor flex print,SFT,,,30.00,42.50,9989,18"
    ].join("\n")
  },
  STAFF: {
    fileName: "coprint-staff-template.csv",
    content: [
      "name,phone_number,role,reports_to_name,reports_to_phone",
      "Anand,9989274400,OWNER,,",
      "Srujan,9989274401,PROJECT_MANAGER,Anand,9989274400"
    ].join("\n")
  }
};

export function downloadAdminSample(importType: AdminImportType) {
  const sample = SAMPLES[importType];
  const url = URL.createObjectURL(new Blob([`${sample.content}\n`], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = sample.fileName;
  link.click();
  URL.revokeObjectURL(url);
}
